import loadable from "@loadable/component";

const OverviewComponent = loadable(() => {
  return import("../components/Overview") as unknown as Promise<React.FC>;
});

const Payroll = () => {
  return <OverviewComponent />;
};

export default Payroll;
